/* eslint-disable import/no-cycle */
import { Stack, HStack, Divider } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import InputPreview from '../formInputs/InputPreview';
import { FormBuilderComponentProps } from '../types';

function PhoneFieldComponent({ fieldId, isAdvanced, labelRightRenderer }: Omit<FormBuilderComponentProps, 'path'>) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <Stack>
      <HStack justify="space-between">
        <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
        <HStack flexShrink={0}>
          <Divider orientation="vertical" />
          {labelRightRenderer}
        </HStack>
      </HStack>
      <FormTextInput fieldId={fieldId} placeholder={t('formBuilder.editorPlaceholder.phone')} isAdvanced={isAdvanced || false} />
      <InputPreview fieldId={fieldId} value="000-000-0000" />
    </Stack>
  );
}

export const PhoneField = React.memo(
  PhoneFieldComponent,
  (prev, next) =>
    /* eslint-disable-next-line  */
    prev.fieldId === next.fieldId && prev.isAdvanced === next.isAdvanced && prev.labelRightRenderer === next.labelRightRenderer,
);
